import { render, staticRenderFns } from "./template.html?vue&type=template&id=145fe425&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=145fe425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fe425",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\CFX\\01_checksheets\\view\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145fe425')) {
      api.createRecord('145fe425', component.options)
    } else {
      api.reload('145fe425', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=145fe425&scoped=true&", function () {
      api.rerender('145fe425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/SimpleModal/SimpleModal.vue"
export default component.exports